import React from 'react';
import MX1 from '/images/mx-images/MX-image-1.png';
import MX2 from '/images/mx-images/MX-image-2.png';
import MX3 from '/images/mx-images/MX-image-3.png';
import MX4 from '/images/mx-images/MX-image-4.png';
import MX5 from '/images/mx-images/MX-image-5.png';
import { Icon, Link, Text, Spacer, Modal } from '@perch-labs/shrike';
import { SUPPORT_PHONE_NUMBER } from 'domain/ux';
import {
  zIndexSupportHeadshotsMiddleLayer,
  zIndexSupportHeadshotsTopLayer,
} from 'domain/style';
import { copyFor } from 'config';
import {
  MxHeadBubbleContainer,
  MxHeadBubble,
  SupportModal,
  SupportModalHeader,
} from './support.style';

const getCopy = copyFor('modules.supportModal');

interface Props {
  onClose: () => void;
}

export const Support = ({ onClose }: Props) => {
  const emailIcon = (
    <Icon icon="Envelope" margin={{ right: '8px' }} color="primaryInverse" />
  );
  const telephoneIcon = (
    <Icon
      icon="Phone"
      margin={{ right: '8px', bottom: '2px' }}
      color="primary"
    />
  );
  return (
    <SupportModal aria-label="Contact Support">
      <SupportModalHeader title={getCopy('title')} onClose={onClose} />
      <Modal.Content>
        <Text margin={{ bottom: '24px' }}>{getCopy('description')}</Text>
        <MxHeadBubbleContainer>
          <MxHeadBubble src={MX1} />
          <MxHeadBubble zIndex={zIndexSupportHeadshotsMiddleLayer} src={MX2} />
          <MxHeadBubble zIndex={zIndexSupportHeadshotsTopLayer} src={MX3} />
          <MxHeadBubble zIndex={zIndexSupportHeadshotsMiddleLayer} src={MX4} />
          <MxHeadBubble src={MX5} />
        </MxHeadBubbleContainer>
        <Text margin={{ bottom: '24px' }}>{getCopy('email.description')}</Text>
        <Link
          fullWidth={true}
          href="mailto:support@arcadia.com"
          type="CTA"
          hideIcon={true}
          backgroundColor="primaryInverse"
        >
          {emailIcon}
          {getCopy('email.link')}
        </Link>
        <Spacer innerText={getCopy('spacer')} padding="16px 0px" />
        <Text>
          {telephoneIcon} {getCopy('phone')}
          <Link href={`tel:1-${SUPPORT_PHONE_NUMBER}`} type="inline">
            {SUPPORT_PHONE_NUMBER}
          </Link>
          .
        </Text>
      </Modal.Content>
    </SupportModal>
  );
};
